import Utils from "../../Utils";
import classes from './RibbonButton.module.css'

export default function RibbonButton({ disabled, onClick, icon, title, className}) {
    return <div className={Utils.getClasses(classes.button,className, disabled && classes.disabled)} onClick={onClick} title={title}>
        <img src={icon} alt={"Icon"} />
    </div>;
}